import { render, staticRenderFns } from "./Stab.vue?vue&type=template&id=fe1c0848&scoped=true&"
import script from "./Stab.vue?vue&type=script&lang=js&"
export * from "./Stab.vue?vue&type=script&lang=js&"
import style0 from "./Stab.vue?vue&type=style&index=0&id=fe1c0848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1c0848",
  null
  
)

export default component.exports